import './App.css';
import '../src/styles/styles.scss';

import { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux';

import { setAuthProperty } from './js/actions/index';

import My404 from './views/My404';
import Login from './views/Login';
import Home from './views/Home';
import PurchaseOrderRestaurant from './views/PurchaseOrderRestaurant';
import PurchaseOrderSupplier from './views/PurchaseOrderSupplier';
import PurchaseOrderApproval from './views/PurchaseOrderApproval.js';
import PurchaseOrder from './views/PurchaseOrder';
import PurchaseOrderConsolidate from './views/PurchaseOrderConsolidate';
//import PurchaseOrderCreate from './views/PurchaseOrderCreate';
//import PurchaseOrderExport from './views/PurchaseOrderExport';
//import PurchaseOrderImport from './views/PurchaseOrderImport';
//import StockInReportExport from './views/StockInReportExport';
import PickingList from './views/PickingList';
import PackingList from './views/PackingList';
//import SupplierAccounts from './views/SupplierAccounts';
//import SupplierProducts from './views/SupplierProducts';
//import SupplierCustomers from './views/SupplierCustomers';
import SupplierInventory from './views/SupplierInventory';
//import SupplierInventoryImport from './views/SupplierInventoryImport';
//import SupplierInventoryProductBranchMapping from './views/SupplierInventoryProductBranchMapping';
import SupplierDataOperations from './views/SupplierDataOperations';
//import SupplierLogistics from './views/SupplierLogistics';
//import SupplierLogisticsPickDelivery from './views/SupplierLogisticsPickDelivery';
//import SupplierLogisticsPickDelivery from './views/SupplierLogisticsPickLoose';
import SupplierLogisticsPickDelivery2 from './views/SupplierLogisticsPickDelivery2';
import GoodsReceiptList from './views/GoodsReceiptList';
//import GoodsReceipt from './views/GoodsReceipt';

//import PurchaseOrderTemplate from './views/PurchaseOrderTemplate';
//import JMPurchaseOrderImport from './views/JMPurchaseOrderImport';
//import JMPOImportRegister from './views/JMPOImportRegister';

import I18NTranslations from './views/I18NTranslations';
import SupplierLogisticsQualityAssurance from './views/SupplierLogisticsQualityAssurance';

import BIPurchaseOrder from './views/BIPurchaseOrder';
import BIProductSort from './views/BIProductSort';

import {getCookie} from './js/global';

import { AbilityContext } from './components/Can';
import { defineAbilityFor } from './js/ability';

const PurchaseOrderCreate = lazy(() => import('./views/PurchaseOrderCreate'));
const PurchaseOrderExport = lazy(() => import('./views/PurchaseOrderExport'));
const PurchaseOrderImport = lazy(() => import('./views/PurchaseOrderImport'));
const SupplierCustomers = lazy(() => import('./views/SupplierCustomers'));
const SupplierAccounts = lazy(() => import('./views/SupplierAccounts')); // OLD DEV
const SupplierInventoryImport = lazy(() => import('./views/SupplierInventoryImport'));
const SupplierInventoryProductBranchMapping = lazy(() => import('./views/SupplierInventoryProductBranchMapping'));
const SupplierLogistics = lazy(() => import('./views/SupplierLogistics'));
const JMPurchaseOrderImport = lazy(() => import('./views/JMPurchaseOrderImport'));
const JMPOImportRegister = lazy(() => import('./views/JMPOImportRegister'));
const GoodsReceipt = lazy(() => import('./views/GoodsReceipt'));
const PurchaseOrderTemplate = lazy(() => import('./views/PurchaseOrderTemplate'));

function mapDispatchToProps(dispatch) {
  return {
    setAuthProperty: payload => dispatch(setAuthProperty(payload))
  };
}

function App(props) {
  // set cookie
  if(getCookie("REACT_APP_VERSION") !== process.env.REACT_APP_VERSION) {
    console.log('localStorage cleared');
    localStorage.clear();
    document.cookie = `REACT_APP_VERSION=${process.env.REACT_APP_VERSION};path=/`;
    props.setAuthProperty({
      "prop":"isLogin",
      "value":false
    });
  }

  let appContent;
  const ability = defineAbilityFor(props.auth);

  if( (!props || !props.auth.isLogin) && window.location.pathname.indexOf('/purchase-order/share/') === -1 ) {
    // <Route path='*' component={Login}/>
    appContent = (
      <Switch>
        <Route exact path='/login/restaurant' render={(props) => <Login {...props} mode="restuarant" />} />
        <Route exact path='/login/supplier' render={(props) => <Login {...props} mode="supplier" />} />
        <Route exact path='/' render={(props) => <Login {...props} mode="" />} />
        <Redirect to='/' />
      </Switch>
    )
  } else {
    if(props.auth.mode === "restuarant") {
      appContent = (
        <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path='/login/restaurant' render={(props) => <Login {...props} mode="restuarant" />} />
          <Route exact path='/login/supplier' render={(props) => <Login {...props} mode="supplier" />} />
          <Route exact path='/' render={(props) => <Home {...props} mode="restuarant" />} />
          <Route exact path='/home' render={(props) => <Home {...props} mode="restuarant" />} />
          <Route exact path='/purchase-orders-export' render={(props) => <PurchaseOrderExport {...props} mode="restuarant" />} />
          {/*<Route exact path='/stock-in-report-export' render={(props) => <StockInReportExport {...props} mode="restuarant" />} />*/}
          <Route exact path='/purchase-orders-restuarant' component={PurchaseOrderRestaurant}/>
          {/*<Route exact path='/purchase-orders-approval' component={PurchaseOrderApproval}/>*/}
          <Route exact path='/purchase-orders/pending-approval'  render={(props) => <PurchaseOrderApproval { ...props} activeKey="1" />} />
          <Route exact path='/purchase-orders/approved'  render={(props) => <PurchaseOrderApproval {...props} activeKey="2" />} />
          <Route exact path='/purchase-orders/rejected'  render={(props) => <PurchaseOrderApproval {...props} activeKey="4" />} />

          <Route exact path='/purchase-orders/approval-consolidate/:supplierId/:branchId/:storageDate' render={(props) => <PurchaseOrderConsolidate readOnly={false} {...props} /> }/>
          <Route exact path='/purchase-order/approval/:supplierId/:branchId/:poId' render={(props) => <PurchaseOrderConsolidate readOnly={false} {...props} /> }/>
          <Route exact path='/purchase-order/:id' render={(props) => <PurchaseOrder readOnly={false} {...props} /> }/>
          <Route exact path="/purchase-order/share/:id" render={(props) => <PurchaseOrder readOnly={true} {...props} /> } />
          <Route exact path="/picking-list" render={(props) => <PickingList readOnly={true} {...props} /> } />
          <Route exact path="/packing-list" render={(props) => <PackingList readOnly={true} {...props} /> } />
          <Route exact path="/weighing-list" render={(props) => <PackingList readOnly={true} weighingList={true} {...props} /> } />
          
          <Route exact path='/purchase-order-template' component={PurchaseOrderTemplate}/>

          <Route exact path='/goods-receipt-list/complete' component={GoodsReceiptList}/>
          <Route exact path='/goods-receipt/:id' component={GoodsReceipt}/>

          <Route exact path='/i18n/translations' render={(props) => <I18NTranslations {...props} />} />

          <Route path='*' exact={true} component={My404} />xw
        </Switch>
        </Suspense>
      )  
    } else if(props.auth.mode === "supplier") {
      appContent = (
        <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path='/login/restaurant' render={(props) => <Login {...props} mode="restuarant" />} />
          <Route exact path='/login/supplier' render={(props) => <Login {...props} mode="supplier" />} />
          <Route exact path='/' render={(props) => <Home {...props} mode="supplier" />} />
          <Route exact path='/home' render={(props) => <Home {...props} mode="supplier" />} />
          <Route exact path='/purchase-orders-supplier' component={PurchaseOrderSupplier}/>
          <Route exact path='/purchase-orders-supplier/confirmed' component={PurchaseOrderSupplier} poType="confirmed"/>

          {/*<Route exact path='/purchase-orders-approval' component={PurchaseOrderApproval}/>*/}
          <Route exact path='/purchase-orders/pending-approval' render={(props) => <PurchaseOrderApproval { ...props} activeKey="1"/>} />
          <Route exact path='/purchase-orders/approved' render={(props) => <PurchaseOrderApproval {...props} activeKey="2"/>} />
          <Route exact path='/purchase-orders/rejected' render={(props) => <PurchaseOrderApproval {...props} activeKey="4"/>} />
          <Route exact path='/purchase-orders/approval-consolidate/:supplierId/:branchId/:storageDate' render={(props) => <PurchaseOrderConsolidate readOnly={false} {...props} /> }/>
          <Route exact path='/purchase-order/approval/:supplierId/:branchId/:poId' render={(props) => <PurchaseOrderConsolidate readOnly={false} {...props} /> }/>
          <Route exact path='/purchase-order/:id' render={(props) => <PurchaseOrder readOnly={false} {...props} /> }/>
          <Route exact path="/purchase-order/share/:id" render={(props) => <PurchaseOrder readOnly={true} {...props} /> } />
          <Route exact path='/purchase-order-import' render={(props) => <PurchaseOrderImport {...props} />} />
          <Route exact path='/jm-purchase-order-import' render={(props) => <JMPurchaseOrderImport {...props} />} />
          <Route exact path='/jm-purchase-order-import-register' render={(props) => <JMPOImportRegister {...props} />} />
          <Route exact path='/purchase-order-create' render={(props) => <PurchaseOrderCreate {...props} />} />
          <Route exact path='/supplier-accounts' render={(props) => <SupplierAccounts {...props} />} />
          <Route exact path='/supplier-customers' render={(props) => <SupplierCustomers {...props} />} />
          <Route exact path='/supplier-inventory-manage' render={(props) => <SupplierInventory {...props} />} />
          <Route exact path='/supplier-inventory-import' render={(props) => <SupplierInventoryImport {...props} />} />
          <Route exact path='/supplier-inventory-branch-product-mapping' render={(props) => <SupplierInventoryProductBranchMapping {...props} />} />
          <Route exact path='/supplier-data-operations' render={(props) => <SupplierDataOperations {...props} />} />
          <Route exact path='/supplier-logistics' render={(props) => <SupplierLogistics {...props} />} />
          <Route exact path='/logistics/pick-delivery' render={(props) => <SupplierLogisticsPickDelivery2 {...props} />} />
          <Route exact path="/picking-list" render={(props) => <PickingList readOnly={true} {...props} /> } />
          <Route exact path="/packing-list" render={(props) => <PackingList readOnly={true} {...props} /> } />
          <Route exact path="/weighing-list" render={(props) => <PackingList readOnly={true} weighingList={true} {...props} /> } />
          <Route exact path='/logistics/order-intelligence' render={(props) => <SupplierLogisticsQualityAssurance {...props} />} />
          <Route exact path='/bi/purchase-order' render={(props) => <BIPurchaseOrder {...props} />} />
          <Route exact path='/bi/product-sort' render={(props) => <BIProductSort {...props} />} />
          <Route path='*' exact={true} component={My404} />
        </Switch>
        </Suspense>
      )
    } else {
      appContent = (
        <Switch>
          <Route exact path='/purchase-order/share/:id' render={(props) => <PurchaseOrder readOnly={true} {...props} /> }/>
          <Route path='*' exact={true} component={My404} />
        </Switch>
      )
    }
  }

  return (
    <AbilityContext.Provider value={ability}>
      {appContent}
    </AbilityContext.Provider>
  );
}

const mapStateToProps = state => {
  const {auth} = state;
  return { auth: auth };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
